<mat-drawer-container hasBackdrop="false">
  <mat-drawer-content>
    @if (redigeringMulig()) {
      @switch (transkripsjonsstatus()) {
        @case ('venterPaaGenerertProtokoll') {
          <inline-melding type="info" class="transkripsjonsstatus ikke-print" data-testid="transkripsjonsstatus">
            <div class="transkripsjonsmelding">
              {{ 'Lydopptaket av møtet ({varighet}) er transkribert' | translate:{varighet: (transkripsjonInformasjon().totalVarighet | duration: 'timerMinutterSekunderStandard')} }},
              <a (click)="redigerProtokoll()" data-testid="rediger-protokoll-fra-transkripsjon">
                {{ 'rediger protokollen' | translate }}
              </a>
              {{ 'for å generer forslag til protokoll fra lydopptaket' | translate }}
            </div>
          </inline-melding>
        }
        @case ('generertProtokollTilgjengelig') {
          <inline-melding type="info" class="transkripsjonsstatus ikke-print" data-testid="transkripsjonsstatus">
            <div class="transkripsjonsmelding">
              {{ 'Det er generert et forslag til protokoll fra lydopptaket av møtet ({varighet})' | translate:{varighet: (transkripsjonInformasjon().totalVarighet | duration: 'timerMinutterSekunderStandard')} }},
              <a (click)="redigerProtokollVisGenerertForslag()" data-testid="rediger-protokoll-fra-transkripsjon">
                {{ 'rediger protokollen' | translate }}
              </a>
              {{ 'for å lime forslagene inn i protokollen' | translate }}
            </div>
          </inline-melding>
        }
       <!-- @case ('transkripsjonFeilet') {
          <inline-melding type="advarsel" class="transkripsjonsstatus ikke-print" data-testid="transkripsjonsstatus">
            {{ 'Transkripsjonen feilet for {antallFeilet} av {antallOpptak} lydopptak av møtet. Det kan derfor ikke genereres et fullstendig forslag til protokoll fra opptaket' | translate:{antallFeilet: transkripsjonInformasjon().antallOpptakTranskripsjonFeilet, antallOpptak: transkripsjonInformasjon().antallOpptak} }}
          </inline-melding>
        }-->
        @case ('transkriberingPaagaar') {
          <inline-melding type="info" class="transkripsjonsstatus ikke-print" data-testid="transkripsjonsstatus">
            <span class="melding">
              <c3-todelt-pai [totalt]="transkripsjonInformasjon().antallOpptak"
                             [andel]="transkripsjonInformasjon().antallOpptakTranskribert + transkripsjonInformasjon().antallOpptakTranskripsjonFeilet"
                             [konfig]="transkripsjonPieKonfig"
                             bredde="20"/>
                <span>{{ '{varighetTranskribert} av lydopptaket har blitt transkribert, vennligst vent mens resten transkriberes' | translate: {varighetTranskribert: transkripsjonInformasjon().varighetTranskribert|duration:'timerMinutterSekunderStandard'} }}</span>
                <button mat-icon-button type="button" (click)="oppdaterInformasjon()" [matTooltip]="'Klikk for å hente oppdatert informasjon'|translate"><mat-icon>refresh</mat-icon></button>
            </span>
          </inline-melding>
        }
      }
    }

    @if (skjemalaasInnloggetBruker() != null) {
      <inline-melding type="advarsel" data-testid="ikkelagredeendringer" (click)="redigerProtokollGjenopprettSkjema()">
        {{ 'Du har ikke-lagrede endringer fra {dato}, klikke her for å gjenopprette disse' | translate:{dato: (skjemalaasInnloggetBruker()!.oppdatertDato | zoneddatetime:'short':true)} }}
      </inline-melding>
    }

    <tittel-verdi stil="vertikal--med-linje" class="dato-sted-blokk" data-testid="protokollførte-møtedetaljer">
      <tittel>
        {{ 'Dato og sted' | translate }}
        @if (redigeringMulig()) {
          <tittel-handlinger-hoeyrestilt class="ikke-print">
            <button mat-stroked-button color="primary" type="button" (click)="redigerProtokoll()" [attr.data-tips-id]="'protokoll-meny'">
              <mat-icon>edit</mat-icon>
              {{ 'Rediger protokoll' | translate }}
            </button>
          </tittel-handlinger-hoeyrestilt>
        }
      </tittel>
      <verdi>
        <tittel-verdi-samling stil="horisontal">
          @if (flerdagsmoete()) {
            <tittel-verdi data-testid="møtedato">
              <tittel><i class="ion-ios-calendar-outline"></i></tittel>
              <verdi>
                {{ protokoll().dato.start | zoneddatetime:'long' }} - {{ protokoll().dato.slutt | zoneddatetime:'long':true }}
              </verdi>
            </tittel-verdi>
          } @else {
            <tittel-verdi [verdi]="protokoll().dato.start | zoneddatetimeSomPlaindate | plaindate: 'full'" data-testid="møtedato">
              <tittel><i class="ion-ios-calendar-outline"></i></tittel>
            </tittel-verdi>
            <tittel-verdi data-testid="møtetidspunkt">
              <tittel><i class="ion-ios-clock-outline"></i></tittel>
              <verdi>
                {{ protokoll().dato.start | zoneddatetimeSomPlainTime | plaintime }} - {{ protokoll().dato.slutt | zoneddatetime:{timeStyle: 'short'}:true }}
              </verdi>
            </tittel-verdi>
          }
          @if (moete().behandlingsSted) {
            <tittel-verdi data-testid="behandlingssted">
              <tittel><i class="ion-ios-location-outline"></i></tittel>
              <verdi>
                <behandlingssted [behandlingssted]="protokoll().behandlingsSted"/>
              </verdi>
            </tittel-verdi>
          }
          @if (moete().behandlingsMaate) {
            <tittel-verdi [verdi]="protokoll().behandlingsMaate" data-testid="behandlingsmåte">
              <tittel><i class="ion-ios-home-outline"></i></tittel>
            </tittel-verdi>
          }
        </tittel-verdi-samling>
      </verdi>
    </tittel-verdi>

    <tittel-verdi stil="vertikal--med-linje" tittel="{{ 'Møtedeltakere' | translate }}" class="deltakere-blokk">
      <verdi>
        <div class="deltakere" [class.uten-representerer-kolonne]="!viserRepresentererKolonne()">
          <!-- Deltatt -->
          <div class="kontainer" data-testid="deltatte">
            <h4>{{ 'Deltatt' | translate }}</h4>
            <span class="kolonnetitler">
              <span class="navn">{{ 'Navn' | translate }}</span>
              <span class="rolle">{{ 'Rolle' | translate }}</span>
              @if (viserRepresentererKolonne()) {
                <span class="representasjoner">
                  <span class="representerer">{{ 'Representerer' | translate }}</span>
                  <span class="eierandel">{{ 'Eierandel' | translate }}</span>
                </span>
              }
              <span class="kommentar">{{ 'Kommentar' | translate }}</span>
              <span class="signatur">{{ 'Signatur' | translate }}</span>
            </span>
            @for (deltaker of deltakere()?.deltatte; track deltaker.id) {
              <protokollfoert-deltakerinformasjon [deltaker]="deltaker" [visRepresentererKolonne]="viserRepresentererKolonne()"/>
            } @empty {
              <div class="ingen">{{ 'ingen' | translate }}</div>
            }
          </div>

          <!-- Forfall -->
          <div class="kontainer" data-testid="forfalte">
            <h4>{{ 'Forfall' | translate }}</h4>
            @for (deltaker of deltakere()?.forfalte; track deltaker.id) {
              <protokollfoert-deltakerinformasjon [deltaker]="deltaker" [visRepresentererKolonne]="viserRepresentererKolonne()"/>
            } @empty {
              <div class="ingen">{{ 'ingen' | translate }}</div>
            }
          </div>

          <!-- Ikke innkalt -->
          @if (ikkeInnkalte().length > 0) {
            <div class="kontainer" data-testid="ikke-innkalte">
              <h4>{{ 'Ikke innkalt' | translate }}</h4>
              @for (deltaker of ikkeInnkalte(); track deltaker.id) {
                <protokollfoert-deltakerinformasjon [deltaker]="deltaker" [visRepresentererKolonne]="viserRepresentererKolonne()"/>
              }
            </div>
          }

          <!-- Eksterne -->
          @if (deltakere().eksterne.length > 0) {
            <div class="kontainer" data-testid="eksterne">
              <h4>{{ 'Eksterne' | translate }}</h4>
              @for (deltaker of deltakere().eksterne; track deltaker.id) {
                <div class="ekstern-deltaker" data-testid="deltakerinformasjon">
                  <span class="navn" data-testid="deltakernavn">{{ deltaker.navn }}</span>
                  <span class="rolle">{{ deltaker.rolle }}</span>
                  @if (viserRepresentererKolonne()) {
                    <span class="representasjoner"></span>
                  }
                  <span class="kommentar" data-testid="kommentar">{{ deltaker.kommentar }}</span>
                  <span class="signatur"></span>
                </div>
              }
            </div>
          }
        </div>
      </verdi>
    </tittel-verdi>

    <tittel-verdi stil="vertikal--med-linje" tittel="{{ 'Saker' | translate }}" class="saker-blokk">
      <verdi>
        @for (sak of saker(); track sak.id) {
          <moeteprotokoll-saksreferat [sak]="sak"/>
        } @empty {
          <div class="ingen">{{ 'ingen' | translate }}</div>
        }
      </verdi>
    </tittel-verdi>

    <!-- id brukes ifbm scrolling til signeringsfelt ved lasting av side når url-query-parm signer=true -->
    <moeteprotokoll-signatarer [signatarer]="signatarer()"
                               medSigneringsstoette="true"
                               [protokollDokumentId]="protokoll().dokumentVersjon.dokumentId"
                               [moete]="moete()"
                               (vedSignert)="protokollSignert($event)"
                               id="signaturfelter"
                               data-tips-id="signaturfelter"
                               data-testid="signaturfelter"/>

    <ramme-med-tittel tittel="{{ 'Protokollbehandling' | translate }}" class="protokollbehandling ikke-print">
      <ramme-innhold>
        <h3>{{ 'Protokollen er til behandling i følgende møter' | translate }}</h3>
        @if (protokoll().behandletISakene.length > 0) {
          <ul>
            @for (sak of protokoll().behandletISakene; track sak.id) {
              <li>
                <a data-testid="protokoll-behandles-i-sak" (click)="gaaTilSak(sak)" class="protokoll-behandles-i-sak">
                  {{ 'Sak {saksnummer} {sakstittel} i {moetetittel} {moetenummer} {dato}'|translate: {saksnummer: sak.nummer, sakstittel: sak.tittel, moetetittel: sak.moete.tittel, moetenummer: sak.moete.nummer, dato: sak.moete.dato.start|zoneddatetimeSomPlaindate|plaindate} }}
                </a>
              </li>
            }
          </ul>
        } @else {
          <tips stil="liten">
            <p>{{ 'Protokollen er ikke til behandling i noe møte.' | translate }}</p>
            <p>{{ 'Du kan registrere protokoll til behandling ved å legge protokolldokumentet til i en sak i et påfølgende møte. Klikk på "legg til dokument" i den aktuelle saken og velg da "Protokolldokument for møte"' | translate }}</p>
          </tips>
        }

        <h3>{{ 'Protokollen i PDF-format' | translate }}</h3>
        <dokument-kortvisning [dokumentversjon]="protokoll().dokumentVersjon" [signeringDeaktivert]="true" (click)="visProtokolldokumentdetaljer()"/>
      </ramme-innhold>
    </ramme-med-tittel>
  </mat-drawer-content>

  <mat-drawer mode="side" position="end" disableClose="false">
    <lukk-mat-drawer-knapp (click)="skjulProtokolldokumentdetaljer()"/>
    @if (viserProtokolldokumentdetaljer()) {
      <dokument-detaljer [dokumentversjon]="protokoll().dokumentVersjon" redigerbar="false"/>
    }
  </mat-drawer>
</mat-drawer-container>
